import { OpportunityType } from '@shared/models/opportunity';

export namespace OpportunityRequirement {
  export enum Mode {
    Recommendation = 'Recommendation',
    Application = 'Application'
  }

  export enum Type {
    Fundamental = 'Fundamental',
    RequiredLater = 'RequiredLater'
  }

  export interface Settings {
    opportunityType: OpportunityType;
    requirement: Mode;
  }

  export interface FundamentalValueRequirement {
    requirementType: Type.Fundamental;
  }

  export interface RequiredLaterValueRequirement {
    requirementType: Type.RequiredLater;
    requirements: Settings[];
  }

  export type ValueRequirement =
    | FundamentalValueRequirement
    | RequiredLaterValueRequirement;

  export function isFundamentallyRequired(
    requirement: ValueRequirement | null
  ) {
    if (!requirement) {
      return false;
    }

    return requirement.requirementType === Type.Fundamental;
  }

  export function isRequiredLaterForMode(
    requirement: ValueRequirement | null,
    mode: Mode,
    opportunityType: OpportunityType
  ): boolean {
    if (!requirement) {
      return false;
    }

    if (!('requirements' in requirement)) {
      return false;
    }

    switch (mode) {
      case Mode.Recommendation:
        return (
          requirement.requirements.findIndex(
            (r) =>
              r.opportunityType === opportunityType &&
              r.requirement === Mode.Recommendation
          ) > -1
        );
      case Mode.Application:
      default:
        return (
          requirement.requirements.findIndex(
            (r) => r.opportunityType === opportunityType
          ) > -1
        );
    }
  }
}
